<template>
  <v-app>
    <v-app-bar app clipped-left color="primary" :dark="theme.dark">
      <v-toolbar-title>
        <v-avatar class="link">
          <span v-if="avatarText" class="headline" v-text="avatarText" />
          <img v-else :src="avatarImg" />
        </v-avatar>

        <div @click="$router.push('/' + siteID + '/doc/' + requestDocID + '/upload')" style="float: right;line-height:1em;" class="ml-3 mt-1 link">
          <div v-text="agentFullName" />
          <div class="caption">
            {{ agentTitle }}<span v-if="agentLic"> - {{ agentLic }}</span>
          </div>
        </div>
      </v-toolbar-title>
      <v-spacer />  
       <v-btn v-if="lan=='fr'" class="d-none d-sm-block" :dark="theme.dark" text @click="setLan('en')">English</v-btn>
      <v-btn v-else class="d-none d-sm-block" :dark="theme.dark" text @click="setLan('fr')">Français</v-btn>    
      <v-btn @click="$router.push('/' + siteID + '/doc/' + requestDocID + '/contact')" class="d-none d-sm-block" :dark="theme.dark" text>{{
        $t("labels.ContactMe")
      }}</v-btn>
    </v-app-bar>

    <v-content>
      <div style="padding-top: 80px;">
        <router-view />
      </div>
    </v-content>

    <v-footer app class="footer text-center" :inset="true">
      <!-- <div style="font-size: 11px;">
        &copy; 2006-{{this.currentYear}}
        <a target="_blank" href="http://www.axiominnovations.com"> Axiom Innovations</a> Inc. All rights reserved.
      </div> -->
      <scarlettFooterVue :withSupportLink="false" />
      <v-spacer></v-spacer>
      <div style="font-size: 11px;">
        <a link color="primary" @click="privacyFlag = true" v-text="$t('labels.Privacy')"></a>
        <a link class="ml-5" color="Primary" @click="termFlag = true" v-text="$t('labels.Terms')"></a>
      </div>
    </v-footer>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>

    <v-dialog v-model="privacyFlag" fullscreen :scrollable="true">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t("labels.PrivacyPolicy") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="privacyFlag = false">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-6">
          <div style="color:black;" v-html="$t('messages.Privacy')"></div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="termFlag" fullscreen :scrollable="true">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t("labels.Terms") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="termFlag = false">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-6">
          <div style="color:black;" v-html="$t('messages.Term')"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import { EventBus } from "@/services/eventBus";
import uiSvc from "@/services/uiService";
import domainHelper from "@/services/domainHelper";
import scarlettFooterVue from '@/shared/components/scarlettFooter.vue';
export default {
   components:{
    scarlettFooterVue
  },
  data() {
    return {
      currentYear: null,
      privacyFlag: false,
      termFlag: false,
      drawer: false,
      loadFlag: false,
      siteID: this.$route.params.siteid,
      token: this.$route.params.token,
      siteConf: {
        user: {},
        site: {}
      }
    };
  },
  methods: {
     setLan(lan){
      localStorageSvc.setLan(lan);
      window.location.reload();
    },
    setFavIcon(src) {
      let head = document.head || document.getElementsByTagName("head")[0];
      var link = document.createElement("link"),
        oldLink = document.getElementById("dynamic-favicon");
      link.id = "dynamic-favicon";
      link.rel = "shortcut icon";
      link.type = "image/png";

      link.href = domainHelper.getAPIHost() + "/ws/AgentFavIcon/" + src;
      if (oldLink) {
        head.removeChild(oldLink);
      }
      head.appendChild(link);
    },

    loadPage() {
      const currentDate = new Date();
      this.currentYear = currentDate.getFullYear();  
      this.loadFlag = true;
      dataSvc
        .getSiteConf(this.siteID)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.siteConf.site = res.data.Link;
            this.siteConf.user = res.data.User;
            this.theme.dark = true;
            this.$vuetify.theme.themes.light.primary = this.siteConf.site.PrimaryColor;
            try {
              if (res.data.Link.AgentProfile.FavIcon) this.setFavIcon(res.data.Link.AgentProfile.FavIcon);
            } catch (err) {
              console.error(err);
            }
          } else {
            localStorageSvc.clear();
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.$router.push("/");
        });
    }
  },
  computed: {
     lan(){
      return localStorageSvc.getLan();
    },
    a() {
      let rv = null;
      try {
        rv = this.siteConf.site.AgentProfile;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentLic() {
      let rv = null;
      try {
        rv = this.a.AgentLic;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentTitle() {
      let rv = null;
      try {
        rv = this.a.Title;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentFullName() {
      let rv = null;
      try {
        rv = this.a.FirstName + " " + this.a.LastName;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    avatarText() {
      let rv = null;
      if (this.a) {
        if (!this.a.AgentPhoto) {
          rv = this.a.FirstName.charAt(0) + this.a.LastName.charAt(0);
        }
      }
      return rv;
    },
    avatarImg() {
      let rv = null;
      if (this.a && this.a.AgentPhoto) {
        rv = domainHelper.getAPIHost() + "/ws/AgentProfilePhoto/" + this.a.AgentPhoto;
      }
      return rv;
    }
  },
  created() {
    this.loadPage();

    EventBus.$on("showprivacy", () => {
      this.privacyFlag = true;
    });
    EventBus.$on("showterm", () => {
      this.termFlag = true;
    });
  },
  beforeDestroy() {
    EventBus.$off("showprivacy");
    EventBus.$off("showterm");
  },
  mounted() {
    uiSvc.setTitle();
  },
  watch: {
    privacyFlag(n) {
      let ele = document.getElementsByTagName("html");
      if (n) {
        ele[0].style.overflow = "hidden";
      } else {
        ele[0].style.overflow = "";
      }
    },
    termFlag(n) {
      let ele = document.getElementsByTagName("html");
      if (n) {
        ele[0].style.overflow = "hidden";
      } else {
        ele[0].style.overflow = "";
      }
    }
  }
};
</script>

<style scoped>
.footer {
  border-top: 1px solid #404040;
}
main {
  padding-top: 0 !important;
}
</style>
